// essa função é usada para gerar a etapa do parecer que tem a ver com o objetivo da área. Essa é a parte inicial
export function calcularParecerObjetivoArea(minimo, objetivosArea, desempenhoPorComponente){
    let parecer = '';
    // Tudo B ou menos
    if(desempenhoPorComponente.every(item => item.notacao <= 2)){
        const notacoes = objetivosArea.map(item => item.texto)
        parecer = `${minimo.texto} Desenvolveu parcialmente a capacidade de ${formatarLista(notacoes)}`;
    }
    // Pelo menos um B
    else if(desempenhoPorComponente.some(item => item.notacao < 3 )){
        const notacaoAdequada = [];
        const notacaoBasica = [];
        desempenhoPorComponente.forEach(componente => {
            if(componente.notacao >= 3){
                objetivosArea.forEach(objetivo => {
                    if(objetivo.disciplina == componente.disciplina){
                        notacaoAdequada.push(objetivo.texto);
                    }
                })
            }else{
                objetivosArea.forEach(objetivo => {
                    if (objetivo.disciplina == componente.disciplina) {
                        notacaoBasica.push(objetivo.texto)
                    }
                })
                
            }
        })

        parecer = `${minimo.texto} Além disso, conseguiu ${formatarLista(notacaoAdequada)}`;
    } 
    // Tudo AD ou mais
    else if (desempenhoPorComponente.every(item => item.notacao >= 3)){
        const notacoes = objetivosArea.map(item => item.texto)
        parecer = `${minimo.texto} Além disso, conseguiu ${formatarLista(notacoes)}`;
    }

    
    return parecer;
}

export function calcularParecerDificuldadesDestaques(desempenhoPorCompetencia, desempenho, disciplinas, inconsistencia = false){
    let parecer = '';
    const inconsistencias = [];

    const disciplinasBasicas = []; 
    const disciplinasAvancadas = [];
    desempenho.forEach(item => {
        if(item.notacao < 3) disciplinasBasicas.push(item);
        if(item.notacao > 3) disciplinasAvancadas.push(item);
    })

    if(disciplinasBasicas.length > 0){
        console.log(disciplinasBasicas);
    }
    
    let competenciasBasicas = disciplinasBasicas.map(disciplina =>{

        // encntrar as competencias dessa disciplina cujo desempenho é básico
        const competencias = desempenhoPorCompetencia.filter(item => disciplina.disciplina === item.disciplina && item.desempenho < 80);

        console.log(competencias)
        
        if(competencias.length > 0){
            let nomeDisciplina = disciplinas.filter(item => disciplina.disciplina == item.id);
            if (nomeDisciplina.length > 0) nomeDisciplina = nomeDisciplina[0].nome;
            return { competencias, nomeDisciplina };
        }else{
            inconsistencias.push({ disciplina: disciplina.disciplina, tipo: "O estudante tem B ou AB mas em nenhum objetivo teve desempenho menor que 80%. Isso fará com que não apareça no parecer que ele atingiu parcialmente alguma competência. Revise a notação ou as avaliações dele. Outro possível problema é o plano não ter nenhuma competência associada." });
            return null;
        }
    }).filter(Boolean)
    

    let competenciasAvancadas = disciplinasAvancadas.map(disciplina => {
        
        // encntrar as competencias dessa disciplina cujo desempenho é avançado
        const competencias = desempenhoPorCompetencia.filter(item => disciplina.disciplina === item.disciplina && item.desempenho >= 92);

    
        if (competencias.length > 0) {
            let nomeDisciplina = disciplinas.filter(item => disciplina.disciplina == item.id);
            if (nomeDisciplina.length > 0) nomeDisciplina = nomeDisciplina[0].nome;
            return { competencias, nomeDisciplina };
        } else {
            inconsistencias.push({ disciplina: disciplina.disciplina, tipo: 'O estudante tem AV mas em nenhum objetivo teve desempenho maior que 92%. Isso fará com que não apareça no parecer que ele excedeu as expectativas em alguma competência. Revise a notação ou as avaliações dele.' });
            return null;
        }
    }).filter(Boolean)
   
 
    
    if(competenciasBasicas.length > 0){
        parecer += formatarCompetencias(competenciasBasicas, 'basica');
    }

    if(competenciasAvancadas.length > 0){
        parecer += formatarCompetencias(competenciasAvancadas, 'avancada');
    }

    if(inconsistencia){
        return { parecer, inconsistencias };
    }else{
        return parecer;
    }

    
}


export function calcularParecerSugestoes(desempenhoPorCriterio, sugestoes, area, desempenhoPorComponente){
    let parecer = '';

    const desempenhoCopia = [...desempenhoPorCriterio];
    const maioresDificuldades = ordenarPorDesempenho(desempenhoCopia);

    let sugestao = sugestoes.filter(item => item.criterio === maioresDificuldades[0].id);
    if(sugestao.length === 0){
        sugestao = sugestoes.filter(item => item.criterio === maioresDificuldades[1].id);
    }
    if (sugestao.length === 0) {
        sugestao = sugestoes.filter(item => item.criterio === maioresDificuldades[2].id);
    }
    if (sugestao.length === 0) {
       alert('Vá até a página de definição de pareceres para adicionar sugestões');
       return
    }

    if (desempenhoPorComponente.some(item => item.notacao < 3)){
        /// se o estudante tem b, pegar o pior desempenho, mesmo que maior que 80
        parecer += `Os professores da área observaram ao longo do trimestre que o aspecto no qual você apresentou maior dificuldade foi ${definirGeneroArigo(maioresDificuldades[0].criterio)} ${maioresDificuldades[0].criterio.toLowerCase()}. ${sugestao[0].sugestao}`;
    }else{
        /// se o estudante não tem b, verificar se tem baixo desempenho em algum critério
        if (maioresDificuldades[0].desempenho < 80) {
            parecer += `Os professores da área observaram ao longo do trimestre que o aspecto no qual você apresentou maior dificuldade foi ${definirGeneroArigo(maioresDificuldades[0].criterio)} ${maioresDificuldades[0].criterio.toLowerCase()}. ${sugestao[0].sugestao}`;
        } else {
            parecer += `Você atingiu os objetivos nas atividades propostas na área nesse trimestre, parabéns pelo resultado alcançado! `;

            // Se estiver interessado(a) em aprimorar ainda mais seus conhecimentos, sugerimos a realização de atividades mais complexas, voltadas para estudantes que desejam aprender mais sobre um tema.
        }

    }
    
    return parecer;

}


function ordenarPorDesempenho(array) {
    return array.sort((a, b) => a.desempenho - b.desempenho);
}

function formatarCompetencias(listaDisciplinas, tipo) {
    
    // Verificar se a lista de disciplinas está vazia
    if (listaDisciplinas.length === 0) {
        return '';
    }

    // Processar cada disciplina
    return listaDisciplinas.map(disciplina => {
        const nomeDisciplina = disciplina.nomeDisciplina;
        const competencias = disciplina.competencias;

        // Formatar a lista de competências para cada disciplina
        const listaFormatada = competencias.map(item => {
            let competencia = item.competencia.trim();

            // Remover ponto do final da competência, se houver
            if (competencia.endsWith('.')) {
                competencia = competencia.slice(0, -1);
            }

            // Transformar a primeira letra em minúscula
            competencia = competencia.charAt(0).toLowerCase() + competencia.slice(1);

            // Avaliar desempenho
            if(tipo !== 'avancada'){
                const desempenhoTexto = item.desempenho < 50 ? 'minimamente' : 'parcialmente';
                return `${desempenhoTexto} a competência de "${competencia}"`;
            }else{
                return `"${competencia}"`;
            }
        });

        // Montar a lista formatada como uma frase
        let competenciasTexto;
        if (listaFormatada.length === 1) {
            competenciasTexto = listaFormatada[0] + ".";
        } else {
            const ultimaPosicao = listaFormatada.length - 1;
            const parteInicial = listaFormatada.slice(0, ultimaPosicao).join(", ");
            const ultimoItem = listaFormatada[ultimaPosicao];
            competenciasTexto = parteInicial + " e " + ultimoItem + ".";
        }

        // Montar o parecer para cada disciplina
        let parecer = `<div>No componente de ${nomeDisciplina},`;
        if (tipo === 'avancada') {
            const habilidadeTexto = listaFormatada.length > 1 ? 'nas competências de' : 'na competência de';
            parecer += ` você excedeu as expectativas ${habilidadeTexto} ${competenciasTexto}`;
        } else {
            parecer += ` você atingiu ${competenciasTexto}`;
        }
        parecer += "</div>";

        return parecer;
    }).join('\n\n');
}

 function definirGeneroArigo(criterio){
    if(criterio.includes('Trabalho em grupo')){
        return 'o';
    }
    return 'a';
 }

function formatarLista(itens) {
    if (itens.length === 0) {
        return ".";
    }
    if (itens.length === 1) {
        return itens[0] + ".";
    }
    const ultimaPosicao = itens.length - 1;
    const parteInicial = itens.slice(0, ultimaPosicao).join(", ");
    const ultimoItem = itens[ultimaPosicao];
    return parteInicial + " e " + ultimoItem + ".";
}